import pythonApiClient from './pythonBaseApi';

const eliminarCheckInApi = {
  // Check-ins del día (orden por hora de check-in)
  listarCheckInsPorFecha: async (proyectoId, fecha) => {
    const response = await pythonApiClient.get(
      '/procesos/hoteleria/eliminar-check-in/check-ins-por-fecha',
      {
        params: { proyecto_id: proyectoId, fecha },
      }
    );
    return response;
  },

  // Eliminar varios check-ins por IDs de asignación
  eliminarCheckInsPorIds: async (proyectoId, asignacionIds, modo = 'checkin_y_reserva') => {
    const response = await pythonApiClient.post(
      '/procesos/hoteleria/eliminar-check-in/eliminar-por-ids',
      {
        proyecto_id: proyectoId,
        asignacion_ids: asignacionIds,
        modo,
      }
    );
    return response;
  },

  // Buscar check-in por DNI
  buscarCheckIn: async (dni, proyectoId) => {
    const response = await pythonApiClient.get('/procesos/hoteleria/eliminar-check-in/buscar-check-in', {
      params: { 
        dni,
        proyecto_id: proyectoId
      }
    });
    return response;
  },

  // Eliminar check-in individual
  eliminarCheckInIndividual: async (dni, proyectoId) => {
    const response = await pythonApiClient.post('/procesos/hoteleria/eliminar-check-in/eliminar-individual', {
      dni,
      proyecto_id: proyectoId
    });
    return response;
  },

  // Validar archivo antes de procesar
  validarArchivo: async (file, proyectoId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('proyecto_id', proyectoId);
    
    const response = await pythonApiClient.post('/procesos/hoteleria/eliminar-check-in/validar-archivo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  },

  // Eliminar check-ins masivos
  eliminarCheckInsMasivo: async (file, autoCompleteDni, proyectoId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('auto_complete_dni', autoCompleteDni);
    formData.append('proyecto_id', proyectoId);
    
    const response = await pythonApiClient.post('/procesos/hoteleria/eliminar-check-in/eliminar-masivo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  },

  // Eliminar TODOS los check-ins del proyecto
  eliminarTodosCheckIns: async (proyectoId) => {
    const response = await pythonApiClient.delete('/procesos/hoteleria/eliminar-check-in/eliminar-todos', {
      params: {
        proyecto_id: proyectoId
      }
    });
    return response;
  }
};

export default eliminarCheckInApi;
